import React, { useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import CategoryStoresContext from 'data-hooks/context/CategoryStoresContext';
import useProductCardContext from 'data-hooks/useProductCardContext';
import ProductCardOnDisplayInShowroomMultiple from './ProductCardOnDisplayInShowroomMultiple';
import ProductCardOnDisplayInShowroomSingle from './ProductCardOnDisplayInShowroomSingle';

const ProductCardOnDisplayInShowroom = () => {
  const location = useLocation();
  const { productStoresMap } = useContext(CategoryStoresContext);
  const productCardContext = useProductCardContext();

  const enableMultipleStores = useMemo(() => {
    if (!location?.search) return false;
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('showMultipleStores') === 'true';
  }, [location?.search]);

  const hasNewStoresData =
    enableMultipleStores &&
    productStoresMap &&
    Object.keys(productStoresMap).length > 0;
  const hasOldSlugData = productCardContext?.onDisplayInShowroomSlug;

  if (hasNewStoresData) {
    return <ProductCardOnDisplayInShowroomMultiple />;
  }

  if (hasOldSlugData) {
    return <ProductCardOnDisplayInShowroomSingle />;
  }

  return null;
};

export default ProductCardOnDisplayInShowroom;
